import { render, staticRenderFns } from "./carousel-minimal.vue?vue&type=template&id=61bd1444&"
import script from "./carousel-minimal.vue?vue&type=script&lang=js&"
export * from "./carousel-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports